import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
  Product,
  Report,
  RowActions,
  SelectionAction,
} from '../../../../../admin/report/report';
import { AlertDialogComponent } from '../../../../../../shared/components/alert-dialog/alert-dialog.component';
import { ModalData } from '../../../../../admin/action/action';
import { TitledModalWithContentService } from '../../../../../../shared/services/titled-modal-with-content.service';
import { CongratulationComponent } from '../../../../../../shared/components/congratulation/congratulation.component';
import { GetFilteredProductsService } from './services/get-filtered-products.service';
import { ProductActionsDelete } from './services/action-products-delete.service';
import { ProductActionsPublish } from './services/action-products-publish.service';
import { ProductActionsUnpublish } from './services/action-products-unPublish.service';
import {
  ProductRoutes,
  ProductTypes,
} from '../../../../../../shared/product/productTypes';
import { LanguageService } from '../../../../../../shared/services/language.service';
import { SellerResendMailService } from 'src/app/dashboard/admin/report/services/seller-resend-mail.service';

@Component({
  selector: 'app-claims-management',
  templateUrl: './claims-management.component.html',
  styleUrls: ['./claims-management.component.scss'],
})
export class ClaimsManagementComponent implements OnInit {
  claimStatus: any = {};

  productStatus: any = {};

  tableColumns: string[] = [
    'productName',
    'claimStatus',
    'due',
    'creation',
    'productExpiry',
    'visitedCount',
    'createdBy',
    'customerName',
    'customerBusinessName',
    'customerMobile',
    'customerEmail',
    'productStatus'
  ];

  displayTableColumns = {};

  selection = new SelectionModel<Product>(true, []);
  loading = false;
  totalNumberOfRecords = 0;
  claimsManagementReportData: any[] = [];

  filterField;
  requestBody: Report = {};
  selectionActions: SelectionAction[] = [];
  reportName: string = '';

  rowActions: RowActions[] = [];

  constructor(
    private translate: TranslateService,
    public getFilteredProductsService: GetFilteredProductsService,
    private resendMailService: SellerResendMailService,
    private DeleteProductService: ProductActionsDelete,
    private PublishProductService: ProductActionsPublish,
    private modal: TitledModalWithContentService,
    private UnPublishProductService: ProductActionsUnpublish,
    public dialog: MatDialog,
    private router: Router,
    private languageService: LanguageService,
  ) {}

  async ngOnInit() {
    if (localStorage.getItem('language')) {
      if (localStorage.getItem('language') === 'ar') {
        this.loadArContent();
      } else if (localStorage.getItem('language') === 'en') {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === 'ar') {
        this.loadArContent();
      } else if (lang === 'en') {
        this.loadEnContent();
      }
    });
    try {
      this.getFilteredProductsService.activateLoader();
      this.requestBody.paginationOptions = {
        start: 0,
        limit: 10,
      };
      this.requestBody.isCollection = true;
      this.updateTable();
    } catch (error) {
      console.log(error);
    }
  }

  loadArContent() {
    this.translate.use('ar');
    this.reportName = 'إدارة المطالبات';

    this.claimStatus = {
      Pending: 'قيد الانتظار',
      Due: 'مستحقة',
      Paid: 'مدفوعة',
    };

    this.productStatus = {
      0: "غير منشورة",
      1: "منشورة"
    };

    this.displayTableColumns = {
      productName: 'الإسم',
      claimStatus: 'حالة المطالبة',
      due: 'تارخ الاستحقاق',
      creation: 'تاريخ الإنتاج',
      productExpiry: 'تاريخ انتهاء الصلاحية',
      visitedCount: 'عدد الزوار',
      createdBy: 'تم بواسطة',
      customerName: 'اسم العميل',
      customerEmail: 'ايميل العميل',
      customerMobile: 'هاتف العميل',
      customerBusinessName: 'اسم العميل التجاري',
      productStatus: "الحالة",
    };

    this.filterField = [
      {
        filterFieldName: "published",
        filterDisplayName: "الحالة",
        defaultValue: "",
        filterOptions: [
          { key: "إظهار الكل", value: null },
          { key: "منشورة", value: "1" },
          { key: "غير منشورة", value: "0" }
        ]
      },
      {
        filterFieldName: 'claimStatus',
        filterDisplayName: 'حالة المطالبة',
        defaultValue: '',
        filterOptions: [
          { key: 'إظهار الكل', value: null },
          { key: 'قيد الانتظار', value: 'Pending' },
          { key: 'مستحقة', value: 'Due' },
          { key: 'مدفوعة', value: 'Paid' },
        ],
      },
      {
        filterFieldName: 'expired',
        filterDisplayName: 'انتهاء صلاحية المطالبة',
        defaultValue: '',
        filterOptions: [
          { key: 'إظهار الكل', value: null },
          { key: 'منتهي الصلاحية', value: '1' },
          { key: 'غير منتهي الصلاحية', value: '0' },
        ],
      },
    ];

    this.rowActions = [
      {
        actionName: 'معاينة',
        actionType: 'icon',
        actionClass: 'btn-default mr-2',
        iconClass: 'fa-eye',
      },
      {
        actionName: 'تعديل',
        actionType: 'icon',
        actionClass: 'btn-info mr-2',
        iconClass: 'fa-edit',
      },
      {
        actionName: 'إعادة ارسال الإيميل',
        actionType: 'icon',
        actionClass: 'btn-info mr-2',
        iconClass: 'fa-solid fa-envelope',
      },
      {
        actionName: 'مشاركة',
        actionType: 'icon',
        actionClass: 'btn-primary',
        iconClass: 'fa-share',
      },
    ];

    this.selectionActions = [
      {
        actionName: 'مسح',
        actionValue: 'delete',
        actionType: 'Button',
        actionClass: 'btn-outline-danger',
      },
      {
        actionName: 'منشورة',
        actionValue: 'publish',
        actionType: 'Button',
        actionClass: 'btn-primary',
      },
      {
        actionName: 'غير منشورة',
        actionValue: 'unpublish',
        actionType: 'Button',
        actionClass: 'btn-outline-warning',
      },
    ];
  }

  loadEnContent() {
    this.translate.use('en');
    this.reportName = 'Manage Claims';

    this.claimStatus = {
      Pending: "Pending",
      Due: 'Due',
      Paid: 'Paid',
    };

    this.productStatus = {
      0: "Un Published",
      1: "Published"
    };

    this.displayTableColumns = {
      productName: 'Name',
      claimStatus: 'Claim Status',
      due: 'Due Date',
      creation: 'Created at',
      productExpiry: 'Expires in',
      visitedCount: 'Visitor Count',
      createdBy: 'Created By',
      customerBusinessName: 'Customer Business Name',
      customerName: 'Customer Name',
      customerMobile: 'Customer Mobile',
      customerEmail: 'Customer Email',
      productStatus: "Status",
    };

    this.filterField = [
      {
        filterFieldName: "published",
        filterDisplayName: "Status",
        defaultValue: "",
        filterOptions: [
          { key: "Show All", value: null },
          { key: "Published", value: "1" },
          { key: "Unpublished", value: "0" }
        ]
      },
      {
        filterFieldName: 'claimStatus',
        filterDisplayName: 'Claim Status',
        defaultValue: '',
        filterOptions: [
          { key: 'Show All', value: null },
          { key: 'Pending', value: 'Pending' },
          { key: 'Due', value: 'Due' },
          { key: 'Paid', value: 'Paid' },
        ],
      },
      {
        filterFieldName: 'expired',
        filterDisplayName: 'Claim Expiry',
        defaultValue: '',
        filterOptions: [
          { key: 'Show All', value: null },
          { key: 'Expired', value: '1' },
          { key: 'Not Expired', value: '0' },
        ],
      },
    ];

    this.rowActions = [
      {
        actionName: 'View',
        actionType: 'icon',
        actionClass: 'btn-default mr-2',
        iconClass: 'fa-eye',
        actionDisableEnableField: 'productTypeName',
        actionDisableValues: ['Quick Cash'],
      },
      {
        actionName: 'Edit',
        actionType: 'icon',
        actionClass: 'btn-info mr-2',
        iconClass: 'fa-edit',
      },
      {
        actionName: 'Resend-email',
        actionType: 'icon',
        actionClass: 'btn-info mr-2',
        iconClass: 'fa-solid fa-envelope',
      },
      {
        actionName: 'Share',
        actionType: 'icon',
        actionClass: 'btn-primary',
        iconClass: 'fa-share',
        actionDisableEnableField: 'productTypeName',
        actionDisableValues: ['Quick Cash'],
      },
    ];

    this.selectionActions = [
      {
        actionName: 'Delete',
        actionValue: 'delete',
        actionType: 'Button',
        actionClass: 'btn-outline-danger',
      },
      {
        actionName: 'Publish',
        actionValue: 'publish',
        actionType: 'Button',
        actionClass: 'btn-primary',
      },
      {
        actionName: 'Unpublish',
        actionValue: 'unpublish',
        actionType: 'Button',
        actionClass: 'btn-outline-warning',
      },
    ];
  }

  isExpired(element: any) {
    return element.expired === true;
  }

  getProductValueByFieldName(fieldName: any, productFieldValues: any): any {
    const allFields: Array<FieldValueModel> = productFieldValues;
    for (const fieldValue of allFields) {
      if (fieldValue.Field?.name === fieldName) {
        return fieldValue.fieldValue;
      }
    }
    return undefined;
  }

  async rowActionClicked(event: any) {
    if (event.action === 'View' || event.action === 'معاينة') {
      this.view(event.key);
    } else if (event.action === 'Edit' || event.action === 'تعديل') {
      this.edit(event.key);
    } else if (
      event.action === 'Resend-email' ||
      event.action === 'إعادة ارسال الإيميل'
    ) {
      this.resendEmail(event.key);
    } else if (event.action === 'Share' || event.action === 'مشاركة') {
      this.openCongratulationDialoug(event.key);
    }
  }

  edit(product: any) {
    this.router.navigate([
      `${ProductRoutes[ProductTypes.Collection]}/edit/` + product.id,
    ]);
  }

  async resendEmail(product: any) {
    const code = product.code;
    const businessId = product.BusinessId;
    const customerEmail = product.customerEmail;

    this.resendMailService.setParams({
      code,
      businessId,
      customerEmail,
      isCollection: true,
    });
    await this.resendMailService.make();
  }

  async selectionActionsCB(event: any) {
    switch (event.action) {
      case 'delete':
        this.delete();
        break;
      case 'publish':
        this.publish();
        break;
      case 'unpublish':
        this.unPublish();
        break;
    }
  }

  async delete() {
    try {
      const productsIdArray = this.selection.selected.map(
        (product) => product.id
      );
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: this.translate.instant('Sellers.Products.SureWantDelete'),
          question: true,
          confirmTextMessage: this.translate.instant('Sellers.Products.Yes'),
          cancelTextMessage: this.translate.instant('Sellers.Products.No'),
        },
      });
      const result = await dialogRef.afterClosed().toPromise();
      if (!result) {
        return;
      }
      this.DeleteProductService.setParams({ productsIdArray: productsIdArray });
      const response = await this.DeleteProductService.make();
      console.log('response message', response.message);
      const modalData: ModalData = {
        title: this.translate.instant('Sellers.Products.DeleteProducts'),
        content: this.translate.instant('Sellers.Products.DeleteSuccessfully'),
        closeButtonName: this.translate.instant('Sellers.Products.Close'),
      };
      this.modal.open(modalData);
      this.updateTable();
      this.getFilteredProductsService.loader().subscribe((val: any) => {
        this.loading = val;
      });
    } catch (err) {
      console.log(err);
    }
  }

  async publish() {
    try {
      const productsIdArray = this.selection.selected.map(
        (product) => product.id
      );
      this.PublishProductService.setParams({
        productsIdArray: productsIdArray,
      });
      const response = await this.PublishProductService.make();
      console.log('response message', response.message);
      const modalData: ModalData = {
        title: this.translate.instant('Sellers.Products.PublishProducts'),
        content: this.translate.instant('Sellers.Products.PublishSuccessfully'),
        closeButtonName: this.translate.instant('Sellers.Products.Close'),
      };
      this.modal.open(modalData);
    } catch (err) {
      console.log(err);
    }
  }

  async unPublish() {
    try {
      const productsIdArray = this.selection.selected.map(
        (product) => product.id
      );
      this.UnPublishProductService.setParams({
        productsIdArray: productsIdArray,
      });
      const response = await this.UnPublishProductService.make();
      console.log('response message', response.message);
      const modalData: ModalData = {
        title: this.translate.instant('Sellers.Products.UnpublishProducts'),
        content: this.translate.instant(
          'Sellers.Products.UnpublishSuccessfully'
        ),
        closeButtonName: this.translate.instant('Sellers.Products.Close'),
      };
      this.modal.open(modalData);
    } catch (err) {
      console.log(err);
    }
  }

  async view(product: any) {
    await this.router.navigate([`${product.code}`]);
  }

  openCongratulationDialoug(product: any) {
    this.dialog.open(CongratulationComponent, {
      panelClass: 'responsive-dialog',
      data: {
        url: `${window.location.origin}/${product.code}`,
        name: product.productName,
        type: ProductTypes.Collection,
        showCongratulation: false,
      },
    });
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
    this.getFilteredProductsService.loader().subscribe((val: any) => {
      this.loading = val;
    });
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize,
    };
    this.updateTable();
    this.getFilteredProductsService.loader().subscribe((val: any) => {
      this.loading = val;
    });
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event,
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.getFilteredProductsService.loader().subscribe((val: any) => {
        this.loading = val;
      });
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction,
      };
    }
    await this.updateTable();
    this.getFilteredProductsService.loader().subscribe((val: any) => {
      this.loading = val;
    });
  }

  async updateTable() {
    this.getFilteredProductsService.activateLoader();
    this.selection.clear();
    this.getFilteredProductsService.setParams(this.requestBody);
    const report = await this.getFilteredProductsService.make();
    this.claimsManagementReportData = report.result;
    this.mapResponse();
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  mapResponse() {
    for (
      let index = 0;
      index < this.claimsManagementReportData.length;
      index++
    ) {
      this.claimsManagementReportData[index].claimStatus =
        this.claimStatus[
          this.claimsManagementReportData[index].claimStatus
        ];
    }
  }
}

interface FieldValueModel {
  id?: number;
  fieldValue?: string;
  createdAt?: string;
  updatedAt?: string;
  ProductId?: number;
  FieldId?: number;
  Field?: FieldModel;
}

interface FieldModel {
  id?: number;
  name?: string;
  width?: number;
  createdAt?: string;
  updatedAt?: string;
  FieldType?: FieldTypeModel;
}

interface FieldTypeModel {
  id?: number;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
}
